App.directive('sizeRatio', ['$window', function ($window) {
    return {
        scope: {
            w: '=',
            h: '='
        },
        link: link,
        restrict: 'A'
    };

    function link(scope, elem, attrs) {
        function onResize(scope) {
            var w = parseFloat(window.getComputedStyle(elem[0]).width);
            var ratio = scope.w / scope.h;
            elem[0].style['height'] = Math.floor(w / ratio) + 'px';
        }

        angular.element(document).ready(function () {
            onResize(scope);
        });

        angular.element($window).on('resize', function () {
            onResize(scope);
        });
    };
}]);